import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Tabs } from "antd";
import MailFilesTab from "./MailFilesTab";
import MFvsPersonsTab from "./MFvsPersonsTab";
import MFvsListTab from "./MFvsListTab";
import MFvsTimelineTab from "./MFvsTimelineTab";
import MFvsTimelineMonthsTab from "./MailFiles/MFvsTimelineMonthsTab";
const { TabPane } = Tabs;
import { getProfile } from "../../core/api/auth";


const MailFile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [forcedTabKey, setForcedTabKey] = useState(null);
  const [user, setUser] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
  

  // Define tab paths mapping using useMemo to prevent recreation on each render
  const tabKeyToPath = useMemo(() => ({
    1: "mail-files",
    2: "mf-vs-persons",
    3: "mf-vs-list",
    4: "mf-vs-timeline-years",
    5: "mf-vs-timeline-months"
  }), []);

  // Create reverse mapping from path to key
  const pathToTabKey = useMemo(() => {
    return Object.entries(tabKeyToPath).reduce(
      (acc, [key, path]) => {
        acc[path] = key;
        return acc;
      },
      {}
    );
  }, [tabKeyToPath]);

  // Get current path from URL
  const currentPath = location.pathname.split("/").pop();
  
  // Determine active tab key based on current path
  const computedKey = pathToTabKey[currentPath] || "1";
  const activeTabKey = forcedTabKey || computedKey;

  // Set default tab on initial load if not on a specific tab path
  useEffect(() => {
    if (!Object.values(tabKeyToPath).includes(currentPath)) {
      navigate(`/mail-files`, { replace: true });
    }
  }, [currentPath, navigate, tabKeyToPath]);

  // Handle tab change
  const handleTabChange = (key) => {
    setForcedTabKey(null);
    navigate(`/${tabKeyToPath[key]}`);
  };

   
  
      // Permission check
      
  return (
    <div className="page-wrapper">
      <Tabs
        activeKey={activeTabKey}
        onChange={handleTabChange}
        className="p-2"
      >
        <TabPane tab="Mail Files" key="1">
          <MailFilesTab />
        </TabPane>
        
        <TabPane tab="MF vs Persons" key="2">
          <MFvsPersonsTab />
        </TabPane>
        
        <TabPane tab="MF vs List" key="3">
          <MFvsListTab />
        </TabPane>
        
        <TabPane tab="MF vs Timeline Years" key="4">
          <MFvsTimelineTab />
        </TabPane>
        <TabPane tab="MF vs Timeline Months" key="5">
          <MFvsTimelineMonthsTab />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default MailFile;
